module.exports = __webpack_public_path__ + "img/lv4.61527ec5.png";